import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { get } from 'lodash';
import { View } from '@zhike/ti-ui';
import { Article } from '@zhike/ti-component';
import Header from 'components/header';
import DragContainer from './drag_container';
import styles from './styles';

// 单项选择题
class Sort extends Component {
  // 参数
  static propTypes = {
    setStepRecord: PropTypes.func,
    step: PropTypes.object,
    stepRecord: PropTypes.object,
    isReport: PropTypes.bool,
    question: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
  };
  static defaultProps = {
    setStepRecord: () => {},
    isReport: false,
    step: {},
    stepRecord: {},
  };

  // 构造函数
  constructor(props) {
    super(props);
    this.state = {
      answer: [],
    };
  }

  // 模块加载
  componentDidMount() {
    const correctAnswer = get(this.props.question, 'materials[0].answer');
    this.initAnswer(this.props.step.id, this.props.stepRecord.answer || [], correctAnswer || []);
  }

  // 更新
  componentWillReceiveProps(nextProps) {
    if (this.props.step.id !== nextProps.step.id) {
      const correctAnswer = get(nextProps.question, 'materials[0].answer');
      this.initAnswer(nextProps.step.id, nextProps.stepRecord.answer || [], correctAnswer || []);
    }
  }

  // 初始化答案
  initAnswer(stepId, answer, correctAnswer) {
    if (this.props.isReport) return false;
    // 生成足够长度的由undefined 组成的answer数组
    const newAnswer = [];
    for (let i = 0; i < correctAnswer.length; i += 1) {
      newAnswer[i] = answer.length > 0 ? answer[i] : i;
    }
    const { mode } = this.props.params;
    const unavailableButtons = [];
    if (stepId === 1) unavailableButtons.push('back');
    if (mode === 'test' && (!answer || answer.length === 0)) unavailableButtons.push('testNext');
    Header.config({
      showButtons: mode === 'test' ? ['testNext', 'testStop'] : ['correct', 'back', 'next'],
      unavailableButtons,
      isShowTime: true,
      onClickNext: () => {
        this.props.setStepRecord('answer', this.state.answer);
        Header.next();
      },
      onClickBack: () => {
        this.props.setStepRecord('answer', this.state.answer);
        Header.back();
      },
    });
    this.setState({ answer: newAnswer });
  }

  // 处理答案
  handleAnswer = answer => {
    this.setState({ answer });
    this.props.setStepRecord('answer', answer);
  }

  // 渲染
  render() {
    const { question, isReport } = this.props;
    const direction = get(question, 'materials[0].direction');
    const origin = get(question, 'materials[0].origin');
    const choices = get(question, 'materials[0].choices');
    if (isReport) {
      return (
        <View>
          {
            direction &&
              <Article
                material={direction}
                isReport
              />
          }
          {
            origin &&
              <Article
                material={origin}
                isReport
              />
          }
          <View>
            {
              choices && choices.map((item, index) => (
                <View
                  key={index}
                  className={[styles.cardBox, styles.cardBoxReport]}
                >
                  <View className={styles.label}>{`${String.fromCharCode(65 + index)}.`}</View>
                  {item.text}
                </View>
              ))
            }
          </View>
        </View>
      );
    }

    return (
      <View className={styles.container}>
        {
          direction &&
            <Article
              material={direction}
            />
        }
        {
          origin &&
            <Article
              material={origin}
              progressWidth={538}
            />
        }
        {
          this.state.answer.length > 0 &&
          <DragContainer
            questionId={question.id}
            answer={this.state.answer}
            choices={choices}
            handleAnswer={this.handleAnswer}
          />
        }
      </View>
    );
  }
}

export default withRouter(Sort);



// WEBPACK FOOTER //
// ./src/components/questions/sort/index.js